import React from "react";
import { Link } from "react-router-dom";

/**
 * Legal document layout — Terms of Service and Privacy Policy share the same
 * chrome. Long-form, Linen ground, Atom Sans, deliberately quiet so the copy
 * carries the page.
 */
export function LegalShell({ testId, title, lastUpdated, publishingNote, children }) {
  React.useEffect(() => {
    if (title) document.title = `${title} | Crowther`;
  }, [title]);
  return (
    <div
      data-testid={testId}
      style={{
        background: "var(--c-linen)",
        color: "var(--c-forest)",
        minHeight: "100vh",
        fontFamily: "var(--font-sans)",
        padding: "clamp(48px, 6vw, 96px) clamp(20px, 4vw, 64px) 96px",
      }}
    >
      <div style={{ maxWidth: 780, margin: "0 auto" }}>
        <Link
          to="/?choose=1"
          data-testid={`${testId}-home`}
          style={{ color: "#3D4A44", fontSize: 13, textDecoration: "none", borderBottom: "1px solid rgba(22,30,27,0.2)", paddingBottom: 2 }}
        >
          &larr; Crowther home
        </Link>

        <h1
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: "clamp(34px, 4vw, 54px)",
            lineHeight: 1.08,
            letterSpacing: "-0.022em",
            fontWeight: 300,
            margin: "24px 0 8px",
          }}
        >
          {title}
        </h1>
        <div style={{ color: "#3D4A44", fontSize: 14, marginBottom: 32 }}>
          Crowther &nbsp;·&nbsp; Last updated: {lastUpdated}
        </div>

        {publishingNote ? (
          <div
            data-testid={`${testId}-publishing-note`}
            style={{
              background: "#ECE6DB",
              border: "1px solid rgba(22,30,27,0.10)",
              borderRadius: 8,
              padding: "16px 18px",
              fontSize: 13.5,
              lineHeight: 1.55,
              color: "#3D4A44",
              marginBottom: 40,
            }}
          >
            <strong style={{ color: "var(--c-forest)", fontWeight: 500 }}>Publishing note (remove before launch): </strong>
            {publishingNote}
          </div>
        ) : null}

        <div className="cw-legal-body">{children}</div>

        <style>{`
          .cw-legal-body h2 {
            font-family: var(--font-sans);
            font-size: 20px;
            line-height: 1.25;
            letter-spacing: -0.012em;
            font-weight: 500;
            margin: 40px 0 12px;
            color: var(--c-forest);
          }
          .cw-legal-body p {
            font-family: var(--font-sans);
            font-size: 16px;
            line-height: 1.7;
            color: #2A342F;
            margin: 0 0 14px;
          }
          .cw-legal-body ul {
            padding-left: 22px;
            margin: 0 0 14px;
          }
          .cw-legal-body li {
            font-family: var(--font-sans);
            font-size: 16px;
            line-height: 1.7;
            color: #2A342F;
            margin-bottom: 8px;
          }
          .cw-legal-body a { color: var(--c-emerald); text-decoration: none; border-bottom: 1px solid var(--c-emerald); }
          .cw-legal-body .cw-legal-table {
            border: 1px solid rgba(22,30,27,0.12);
            border-radius: 8px;
            overflow: hidden;
            margin: 12px 0 18px;
          }
          .cw-legal-body .cw-legal-table > div {
            display: grid;
            grid-template-columns: 1.4fr 1.6fr 1fr;
            gap: 0;
            border-bottom: 1px solid rgba(22,30,27,0.10);
            font-size: 14px;
            line-height: 1.55;
          }
          .cw-legal-body .cw-legal-table > div:last-child { border-bottom: none; }
          .cw-legal-body .cw-legal-table > div > span {
            padding: 10px 14px;
            border-right: 1px solid rgba(22,30,27,0.08);
          }
          .cw-legal-body .cw-legal-table > div > span:last-child { border-right: none; }
          .cw-legal-body .cw-legal-table > div.head {
            background: #ECE6DB;
            font-weight: 500;
            color: var(--c-forest);
          }
        `}</style>
      </div>
    </div>
  );
}
